import { formatMoney } from '@/utils/currency';
import type { ItemPromoPreview } from '@/utils/promotions';

export function PosSaleBadge({ preview }: { preview: ItemPromoPreview | null }) {
  if (!preview) return null;
  return (
    <span
      className="inline-flex items-center rounded-full bg-rose-600 text-white text-[10px] font-bold px-1.5 py-0.5 leading-tight max-w-[9.5rem] truncate"
      title={preview.badge}
    >
      {preview.badge}
    </span>
  );
}

export function PosPromoPrice({
  price,
  preview,
  className = '',
}: {
  price: number;
  preview: ItemPromoPreview | null;
  className?: string;
}) {
  if (preview?.strikethrough && preview.promoPrice != null) {
    return (
      <span className={className}>
        <span className="line-through text-gray-400 font-normal mr-1">{formatMoney(preview.originalPrice)}</span>
        <span className="text-rose-600 font-semibold">{formatMoney(preview.promoPrice)}</span>
      </span>
    );
  }
  return <span className={className}>{formatMoney(price)}</span>;
}
